import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { onValue, push, ref as sRef } from "firebase/database";
import { realtimedb } from "../../../FirebaseConfig";
import { getAllData } from "../../../Utils/firebaseServices";
import { FaSearch, FaUserTie } from "react-icons/fa";
import { MdKeyboardArrowLeft, MdSend } from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";
import { LiaGgCircle } from "react-icons/lia";
import { CiFaceSmile } from "react-icons/ci";
import Picker from "@emoji-mart/react"; // 👈 Import emoji picker
import data from "@emoji-mart/data";
import {
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import { storage } from "../../../FirebaseConfig";

const sanitizeEmail = (email) => email.replace(/\./g, "_");

const EmployeeChatHere = () => {
  const { email: otherEmail } = useParams();
  const currentUser = JSON.parse(localStorage.getItem("admin"));
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [employeeName, setEmployeeName] = useState("Loading...");
  const [openSelect, setOpenSelect] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const fileInputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);


  const currentEmail = currentUser?.email;
  const chatId =
    currentEmail && otherEmail
      ? [sanitizeEmail(currentEmail), sanitizeEmail(otherEmail)]
          .sort()
          .join("_")
      : null;

  useEffect(() => {
    const fetchEmployeeName = async () => {
      try {
        await getAllData("financeUserPortal", (users) => {
          const matchedUser = users.find((user) => user.email === otherEmail);
          setEmployeeName(matchedUser ? matchedUser.name : "Unknown User");
        });
      } catch (err) {
        console.error("Error fetching employee data", err);
        setEmployeeName("Error");
      }
    };

    if (otherEmail) fetchEmployeeName();
  }, [otherEmail]);

  useEffect(() => {
    if (!chatId) return;

    const msgRef = sRef(realtimedb, `chats/${chatId}`);

    const unsub = onValue(msgRef, (snap) => {
      const data = snap.val();
      const arr = data
        ? Object.values(data).sort((a, b) => a.timestamp - b.timestamp)
        : [];
      setMessages(arr);

      //  Store last read timestamp only when viewing this chat
      if (arr.length > 0) {
        const lastMsgTimestamp = arr[arr.length - 1].timestamp;
        localStorage.setItem(`lastRead_${chatId}`, lastMsgTimestamp);
      }
    });

    return () => unsub();
  }, [chatId]);
  

  const handleSend = async () => {
    if (!message.trim()) return;
    if (!currentEmail || !otherEmail) {
      console.error("Sender or receiver email missing");
      return;
    }

    const chatId = [sanitizeEmail(currentEmail), sanitizeEmail(otherEmail)]
      .sort()
      .join("_");
    const chatRef = sRef(realtimedb, `chats/${chatId}`);

    await push(chatRef, {
      text: message.trim(),
      sender: currentEmail,
      timestamp: Date.now(),
    });

    setMessage("");
  };


  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages]);

  const handleSendFile = async (file) => {
    if (!file || !currentEmail || !otherEmail) return;

    const filePath = `chat_files/${Date.now()}_${file.name}`;
    const fileRef = storageRef(storage, filePath);

    try {
      await uploadBytes(fileRef, file);
      const fileURL = await getDownloadURL(fileRef);

      const isImage = file.type.startsWith("image/");
      const fileType = isImage ? "image" : "file";

      const chatRef = sRef(realtimedb, `chats/${chatId}`);
      await push(chatRef, {
        fileURL,
        fileName: file.name,
        fileType,
        mimeType: file.type,
        sender: currentEmail,
        timestamp: Date.now(),
      });
    } catch (err) {
      console.error("File upload error:", err);
    }
  };
  

  if (!currentEmail) {
    alert("Admin user not logged in correctly");
    return;
  }

  return (
    <div
      style={{
        position: "sticky",
        height: "94vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#ECFAE5",
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <header
        style={{
          position: "sticky",
          top: 0,
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px",
          flexWrap: "wrap",
          backgroundColor: "#f0f0f0",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          zIndex: 999,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <Link className="searchIcon" to="/chat" style={{ color: "#333" }}>
            <MdKeyboardArrowLeft size={30} />
          </Link>
          <div
            style={{
              padding: "10px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#ddd",
            }}
          >
            <FaUserTie size={28} color="black" />
          </div>
          <p
            style={{
              fontSize: "clamp(18px, 2.5vw, 22px)",
              fontWeight: "bold",
              margin: 0,
              color: "#333",
            }}
          >
            {employeeName}
          </p>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <div className="searchIcon" style={{ position: "relative" }}>
            <input
              placeholder="Search..."
              style={{
                padding: "8px 30px 8px 10px",
                borderRadius: "10px",
                border: "1px solid #ccc",
                minWidth: "150px",
              }}
            />
          </div>
          <FaSearch className="searchIcon" />

          <button
            style={{
              border: "none",
              cursor: "pointer",
              background: "transparent",
            }}
            onClick={() => setOpenSelect((prev) => !prev)}
          >
            <BsThreeDotsVertical fontSize={20} />
          </button>

          {openSelect && (
            <div
              style={{
                position: "absolute",
                top: "60px",
                right: "10px",
                backgroundColor: "#fff",
                boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                borderRadius: "6px",
                padding: "10px",
                zIndex: 1000,
                minWidth: "120px",
              }}
            >
              {["Media, links, and docs", "Mute Notification", "More"].map(
                (item, idx) => (
                  <p
                    key={idx}
                    style={{ margin: "0 0 8px", cursor: "pointer" }}
                    onClick={() => setOpenSelect(false)}
                  >
                    {item}
                  </p>
                )
              )}
            </div>
          )}
        </div>
      </header>
      {/* Messages */}
      <div
        ref={scrollRef}
        style={{
          flex: 1,
          padding: "16px",
          overflowY: "auto",
        }}
      >
        {messages.map((msg, idx) => (
          <div
            key={idx}
            style={{
              textAlign: msg.sender === currentEmail ? "right" : "left",
              marginBottom: "8px",
            }}
          >
            <div
              style={{
                display: "inline-block",
                padding: "8px 12px",
                backgroundColor:
                  msg.sender === currentEmail ? "#D1F7C4" : "#EEE",
                borderRadius: "10px",
                fontSize: "14px",
                maxWidth: "70%",
                wordWrap: "break-word",
              }}
            >
              {msg.text && <p style={{ margin: 0 }}>{msg.text}</p>}

              {msg.fileType === "image" && msg.fileURL && (
                <img
                  src={msg.fileURL}
                  alt={msg.fileName}
                  style={{
                    maxWidth: "200px",
                    marginTop: "5px",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                  onClick={() => setSelectedImage(msg.fileURL)}
                />
              )}

              {selectedImage && (
                <div
                  onClick={() => setSelectedImage(null)} // close on background click
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.85)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                    cursor: "zoom-out",
                  }}
                >
                  <img
                    src={selectedImage}
                    alt="Full View"
                    style={{
                      maxWidth: "90%",
                      maxHeight: "90%",
                      borderRadius: "8px",
                      boxShadow: "0 0 20px rgba(0,0,0,0.5)",
                    }}
                    onClick={(e) => e.stopPropagation()} // avoid closing when clicking image itself
                  />
                </div>
              )}

              {msg.fileType === "file" && msg.fileURL && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "10px",
                    backgroundColor: "#f5f5f5",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    marginTop: "8px",
                    maxWidth: "300px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "24px",
                      color: "#555",
                    }}
                  >
                    📁
                  </div>

                  <div style={{ flex: 1 }}>
                    <a
                      href={msg.fileURL}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        margin: 0,
                        fontWeight: "bold",
                        color: "#333",
                        wordBreak: "break-all",
                      }}
                    >
                      {msg.fileName}
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Footer Input */}
      <footer
        style={{
          position: "sticky",
          bottom: 0,
          width: "100%",
          backgroundColor: "#f0f0f0",
          padding: "10px",
          boxShadow: "0 -2px 4px rgba(0,0,0,0.1)",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            position: "relative",
          }}
        >
          {/* Emoji Picker Button */}
          <button
            onClick={() => setShowEmojiPicker(!showEmojiPicker)}
            className="searchIcon"
            style={{
              fontSize: "26px",
              color: "#000",
              border: "none",
              borderRadius: "8px",
              backgroundColor: "transparent",
            }}
          >
            <CiFaceSmile />
          </button>

          {/* Emoji Picker */}
          {showEmojiPicker && (
            <div
              style={{
                position: "absolute",
                bottom: "60px",
                left: "10px",
                zIndex: 999,
              }}
            >
              <Picker
                data={data}
                onEmojiSelect={(emoji) =>
                  setMessage((prev) => prev + emoji.native)
                }
                theme="light"
              />
            </div>
          )}

          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) handleSendFile(file);
            }}
          />

          {/* clickable icon that opens file selector */}
          <button
            onClick={() => fileInputRef.current.click()}
            className="searchIcon"
            style={{
              fontSize: "26px",
              color: "#000",
              border: "none",
              borderRadius: "8px",
              backgroundColor: "transparent",
              cursor: "pointer",
            }}
          >
            <LiaGgCircle />
          </button>
          <input
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault(); // prevent newline
                handleSend(); // send the message
              }
            }}
            style={{
              flexGrow: 1,
              padding: "10px",
              fontSize: "16px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              minWidth: "100px",
            }}
            placeholder="Type a message..."
          />

          <button
            onClick={handleSend}
            style={{
              fontSize: "28px",
              color: "#000",
              border: "none",
              borderRadius: "8px",
              backgroundColor: "transparent",
            }}
          >
            <MdSend />
          </button>
        </div>
      </footer>
    </div>
  );
};

export default EmployeeChatHere;
